import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { HeadCellImplementationProps } from '../../../../../components/muiLegacy/Tables/KeywordTable/HeadCells/models';
import { CommandGq } from '../../../../../graphql/projects/queries/contentPlan/useGetContentTasksGq';
import { List, ListItem } from '@material-ui/core';
import HeadCell from '../../../../../components/muiLegacy/Tables/Shared/HeadCell';
import { ContentActionGq } from '../../../../../graphql/projects/models/ContentActionGq';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';
import TaskAction from './TaskAction';
import HeadCellStandardOptions from '../../../../../components/muiLegacy/Tables/Shared/HeadCellStandardOptions';
import VoxelMenuItemContainer from '../../../../../components/voxel/PopoverMenu/VoxelMenuItemContainer';

export interface HeadCellActionProps extends HeadCellImplementationProps {
  command: CommandGq;
  setCommand: Dispatch<SetStateAction<CommandGq>>;
  projectId: number;
}

const HeadCellAction: React.FC<HeadCellActionProps> = ({
  command,
  setCommand,
  projectId,
  basicConfig,
  basicState,
}) => {
  const { query, contentActions } = projectsApiService.queries.useGetContentActions({
    projectId: projectId,
  });

  const contentActionList = query.loading ? [] : contentActions;

  const actionList = useMemo(() => {
    if (!command.filtering.actions.length) {
      return contentActionList?.map((a) => ({
        action: a,
        selected: false,
      }));
    } else {
      let selectedActions = contentActionList
        ?.map((a, index) => ({
          index: index,
          action: a,
          selected: true,
        }))
        .filter((a) => command.filtering.actions.includes(a.action));
      let unselectedActions = contentActionList
        ?.map((a, index) => ({
          index: index,
          action: a,
          selected: false,
        }))
        .filter((a) => !command.filtering.actions.includes(a.action));

      return [...selectedActions, ...unselectedActions].sort((a, b) => a.index - b.index);
    }
  }, [command.filtering.actions, contentActions, query.loading]);

  const handleFilterChange = (value: ContentActionGq, selected: boolean) => {
    setCommand((prev) => {
      const actions = prev.filtering.actions.filter((a) => !(a === value));
      selected && actions.push(value);
      return {
        ...prev,
        filtering: { ...prev.filtering, actions },
      };
    });
  };

  return (
    <HeadCell
      hasFilter={!!command.filtering.actions.length}
      align={'center'}
      basicConfig={basicConfig}
      basicState={basicState}
    >
      <VoxelMenuItemContainer size="md">
        <HeadCellStandardOptions basicConfig={basicConfig} basicState={basicState} />
        <List>
          {actionList.map((a, index) => (
            <ListItem
              selected={a.selected}
              key={index}
              button
              onClick={() => handleFilterChange(a.action, !a.selected)}
            >
              <TaskAction action={a.action} size={'small'} />
            </ListItem>
          ))}
        </List>
      </VoxelMenuItemContainer>
    </HeadCell>
  );
};

export default HeadCellAction;
